/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { VideoPlayButton } from 'ui/atoms/VideoPlayButton/VideoPlayButton';
import { Section } from 'ui/molecules/Section/Section';

import styles from './MaActivityDemoSection.module.scss';

const VIDEO_SRC = '/storage/base/funding_database/ma-activity-tour-light.mp4';
const POSTER_SRC = '/storage/base/funding_database/straightfoward_filtering_and_browsing.jpg';

export const MaActivityDemoSection = () => {
  const { t } = useInt();
  const wrapRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) {
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const handlePlay = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    setPlaying(true);
    video.play().catch(() => {});
  };

  return (
    <div ref={wrapRef}>
      <Section background="#EEF1FA" className={cn(styles.section, visible && styles.visible)}>
        <div className={styles.head}>
          <TitleBlock
            title={t('See it on a live profile.')}
            description={t('One company record — funding, investors, financials, people, and signals.')}
          />
        </div>

        <div className={styles.frame}>
          {!playing && (
            <div className={styles.overlay}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src={POSTER_SRC} alt={t('Product tour preview')} className={styles.poster} />
              <VideoPlayButton onClick={handlePlay} />
            </div>
          )}

          <video
            ref={videoRef}
            muted={false}
            loop
            playsInline
            className={cn(styles.video, playing && styles.videoVisible)}
          >
            <source src={VIDEO_SRC} type="video/mp4" />
          </video>
        </div>
      </Section>
    </div>
  );
};
